import { type SetStateAction, useEffect, useRef } from 'react'

import { useInfiniteScroll } from '../../../../../../hooks/useInfiniteScroll'
import { useInfiniteProjectsQuery } from '../../../../../../services/hooks/projects/queries/useProjectQuery'
import { ArchivededProjectsList } from './ArchivedProjectsList'
import { type ProjectDomain } from '../../../../../../types/domain/project-domain'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type ScrollArquivedProjectsContainerProps = {
  filters: FiltersDomain
  setFilters: React.Dispatch<SetStateAction<FiltersDomain>>
  onArquivedProjectItemClick: (archivedProject: ProjectDomain) => void
}

export const ScrollArquivedProjectsContainer = ({
  filters,
  setFilters,
  onArquivedProjectItemClick,
}: ScrollArquivedProjectsContainerProps) => {
  const listRef = useRef<HTMLDivElement>(null)

  const { data, hasNextPage, fetchNextPage } = useInfiniteProjectsQuery(filters)

  const mergedArquivedProjectsPages = data?.pages.reduce(
    (acc: ProjectDomain[], { data }) => [...acc, ...data],
    []
  )

  useEffect(() => {
    setFilters((prevState) => ({ ...prevState, take: 15 }))
  }, [])

  useInfiniteScroll(listRef, hasNextPage, fetchNextPage)

  return (
    <ArchivededProjectsList
      ref={listRef}
      archivedProjects={mergedArquivedProjectsPages || []}
      onArquivedProjectItemClick={onArquivedProjectItemClick}
    />
  )
}
